
  import ScreenSize from '@/mixins/ScreenSize';
  import draggable from 'vuedraggable';

  export default {
    name: 'MultipleElement',
    components: {draggable},
    mixins: [ScreenSize],
    props: {
      elements: {
        type: Array,
        required: true,
      },
      text: {
        type: String,
        required: false,
        default: '',
      },
      panel: {
        type: Boolean,
        required: false,
      },
      draggable: {
        type: Boolean,
        required: false,
      },
    },
    data: () => ({
      drag: false,
      internalElements: [],
    }),
    created() {
      this.internalElements = this.elements;
    },
    methods: {
      addElement() {
        this.internalElements.push({});
        this.$emit('element-added');
      },
      removeElement(i) {
        return () => {
          this.internalElements.splice(i, 1);
          this.$emit('element-removed');
        };
      },
    },
  };
